"use client";

import dynamic from "next/dynamic";

import { commonFormFieldId } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const formConsentCheckboxListInputs = [
  ...commonFormFieldId,
  {
    name: "displayConsent",
    type: "string",
    enum: ["onlyNotLoggedIn", "onlyLoggedIn", "always"],
  },
] as const satisfies Inputs;

export const FormConsentCheckboxListComponent = {
  name: "FormConsentCheckboxList",
  component: dynamic(async () =>
    withValidation(
      formConsentCheckboxListInputs,
      (await import("./FormConsentCheckboxList")).FormConsentCheckboxList,
      "FormConsentCheckboxList"
    )
  ),
  inputs: formConsentCheckboxListInputs,
};
